<script>
import '@bhplugin/vue3-datatable/dist/style.css';
export default {
    components: {},
    data: () => ({
        debug: false,
        auth_user: {
            name: 'Daniel',
            email: 'daniel.alamo@gmail.com',
            status: 'available', //available, busy, away
        },
    }),
    methods: {
        toggleDebug: window.toggleDebug || (() => {}),
    },
    mounted() {
        this.debug = JSON.parse(sessionStorage.getItem('debug')) || false;
    },
    watch: {
        debug(newValue, oldValue) {
            if (typeof axios != 'undefined') {
                axios.get(`/api/app-debug?debug=${newValue ? 1 : 0}`);
            }
        },
    },
    computed: {
        avatarStatusClass() {
            switch(this.auth_user.status) {
                case 'available': return 'avatar-status-success'
                case 'away': return 'avatar-status-warning'
                case 'busy': return 'avatar-status-danger'
            }
            return `avatar-status-success`
        }
    }
}
</script>
